import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import * as WebhookActionMetadataKeys from 'automation-ui-action-features/actions/webhook/constants/WebhookActionMetadataKeys';
import FormulaTextLabel from 'automation-ui-formula-editor/formula-editor/data-passing/FormulaTextLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const WebhookActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail',
  options
}) => {
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.webhook.action-detail.content",
    options: Object.assign({}, options, {
      requestMethod: actionMetadata.getMethod(),
      url: /*#__PURE__*/_jsx(TruncateString, {
        children: /*#__PURE__*/_jsx(FormulaTextLabel, {
          text: actionMetadata.get(WebhookActionMetadataKeys.URL) || ''
        })
      })
    })
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.webhook.action-preview.content",
    options: Object.assign({}, options, {
      requestMethod: actionMetadata.getMethod(),
      url: /*#__PURE__*/_jsx(TruncateString, {
        children: /*#__PURE__*/_jsx(FormulaTextLabel, {
          text: actionMetadata.get(WebhookActionMetadataKeys.URL) || ''
        })
      })
    })
  });
};
export default WebhookActionDetail;